/**
 * @generated SignedSource<<86aef0f310ea10e30dba84280d2d37e0>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type view_issueViewFoundation_ConfigureIssueFF$data = {
  readonly configurationUrl: AGG$URL | null | undefined;
  readonly key: string;
  readonly " $fragmentType": "view_issueViewFoundation_ConfigureIssueFF";
};
export type view_issueViewFoundation_ConfigureIssueFF$key = {
  readonly " $data"?: view_issueViewFoundation_ConfigureIssueFF$data;
  readonly " $fragmentSpreads": FragmentRefs<"view_issueViewFoundation_ConfigureIssueFF">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "view_issueViewFoundation_ConfigureIssueFF",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "key"
    },
    {
      "kind": "ScalarField",
      "name": "configurationUrl"
    }
  ],
  "type": "JiraIssue"
};

(node as any).hash = "486b56b3e11a9c5be67d79e8c74083ec";

export default node;
